<div class="main-section" [ngClass]="{ 'cbm-plan-overview': isPlanSevenOverview }">
    <fcc-badge [isInUse]="isInUse" *ngIf="isLineDetailsBBL"></fcc-badge>
    <div>
        <div>
            <p class="fact-header"> {{ response?.title }} </p>
            <p class="fact-subheader"> {{ response?.serviceTitle }} </p>
            <p class="tier-title"> {{ response?.tierTitle }} </p>
            <p class="row-header"> {{ response?.disclosure }} </p>
        </div>
        <ng-container>            
            <section *ngFor="let region of response?.regions">
                <hr class="region-hr"/>
                <ng-container *ngIf="region?.sections">
                    <section *ngFor="let section of region.sections; index as sectionInd">
                        <div class="section-container">
                            <div class="section-header" [ngClass]="{ 'full-width': !section.headingValue }">
                                {{ section.headingKey ? section.headingKey : ''  }}
                            </div>
                            <div class="section-value" *ngIf="section.headingValue">
                                <cms-text [broadbandLabelLink]="true" [originalText]="section.headingValue">
                                </cms-text>
                            </div>
                        </div>
                        <ng-container *ngIf="section?.description">
                            <div class="description-container" *ngFor="let eachDes of section.description; index as messageInd">
                                <cms-text [broadbandLabelLink]="true" [originalText]="eachDes">
                                </cms-text>
                                <hr class="description-hr" *ngIf="!section.rows && messageInd < section.description.length - 1">
                            </div>
                        </ng-container>
                        
                        <ng-container *ngIf="section?.pricingTable">
                            <div class="pricing-table-container">
                                <div class="table-header">
                                    <div class="header-text"></div>
                                    <div class="header-text-value"><p>{{ section.pricingTable.heading }}</p></div>
                                </div>
                                <div class="row" *ngFor="let row of section.pricingTable.rows">
                                    <div class="row-key-value left">
                                        <cms-text [originalText]="row.keyText"></cms-text>
                                    </div>
                                    <div class="row-key-value right">
                                        <cms-text [originalText]="row.valueText"></cms-text>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="section?.rows">
                            <section class="section-row-container" *ngFor="let row of section.rows">
                                <div class="section-rows">
                                    <div [id]="row.id" class="row-key" [ngClass]="{ 'full-width': !row.headingValue }">
                                        <cms-text [broadbandLabelLink]="true" [originalText]="row.headingKey"></cms-text> 
                                    </div>
                                    <div class="row-value" *ngIf="row.headingValue">
                                        <cms-text [originalText]="row.headingValue"></cms-text>
                                    </div>
                                </div>
                                <ng-container *ngIf="row?.subRows">
                                    <section *ngFor="let subRow of row.subRows">
                                        <div class="sub-rows">
                                            <div class="sub-row-key">
                                                <cms-text [originalText]="subRow.keyText"></cms-text> 
                                            </div>
                                            <div class="sub-row-value">
                                                <cms-text [originalText]="subRow.valueText"></cms-text> 
                                            </div>
                                        </div>
                                        <ng-container *ngIf="subRow?.disclaimer">
                                            <div class="sub-row-disclaimer" *ngFor="let eachDisc of subRow.disclaimer">
                                                <cms-text [originalText]="eachDisc"></cms-text>
                                            </div>
                                        </ng-container>
                                    </section>
                                </ng-container>
                            </section>
                        </ng-container>
                        <ng-container *ngIf="section?.disclaimer">
                            <div class="description-container" *ngFor="let eachDisc of section.disclaimer">
                                <cms-text [broadbandLabelLink]="true" [originalText]="eachDisc">
                                </cms-text>
                            </div>
                        </ng-container>
                        <div *ngIf="section?.description || section?.pricingTable || section?.rows || section?.disclaimer">
                            <hr class="section-hr" *ngIf="sectionInd < region.sections.length - 1" />
                        </div>
                    </section>
                </ng-container>
            </section>
        </ng-container>
    </div>
    <p class="label-id-row">{{ response?.labelId }}</p>
</div>
